import ComingSoon from 'pages/comingSoon/comingSoon';
import { AdminScreen } from 'pages/admin/admin';
import { AccountCreationScreen } from 'pages/invitation/createAccount/createAccount';
import { GuestInviteScreen } from 'pages/invitation/guest/guest';
import Invitation from 'pages/invitation/invitation';
import { InvitationSuccessScreen } from 'pages/invitation/success/success';
import { CreateRewardScreen } from 'pages/admin/createReward/createReward';
// import Menu from 'pages/menu/menu';

export const routes = [
	// { path: '/', title: 'Home', component: YourComponent }
	// { path: '/menu', title: 'Menu', component: Menu },
	{ path: '*', title: 'Coming Soon', component: ComingSoon },
	{ path: '/admin', title: 'Admin', component: AdminScreen },
	{ path: '/admin/create-reward', title: 'Admin | Create Rewards', component: CreateRewardScreen },
	{ path: '/invitation', title: 'Invitation', component: Invitation },
	{ path: '/invitation/account', title: 'Create Account', component: AccountCreationScreen },
	{ path: '/invitation/guest', title: 'Invite Guest', component: GuestInviteScreen },
	{ path: '/invitation/success', title: 'Success', component: InvitationSuccessScreen },
];
